import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter} from 'react-router-dom';
import CreateEnvironment from "./APP/CreateEnvironment/CreateEnvironment";
import CustomerListAPP from "./APP/CustomerList/CustomerList";
import CustomerListACC from "./ACC/CustomerList/CustomerList";
import CustomerListACPP from "./ACPP/OrganisationList/OrganisationList";
import App from "./App";
import AppGroups from "./APP/AppGroups/AppGroups";
import SelfServiceTemplate from "./SelfServiceTemplate";
import Contact from "./General/Contact/Contact";
import {MsalProvider} from '@azure/msal-react';
import {msalConfig} from './msal/authConfig';
import {PublicClientApplication} from '@azure/msal-browser';
import APPOctoSync from "./APP/APPOctoSync/APPOctoSync";
import Logout from "./General/Logout/Logout";
import APPLinkDB from "./APP/APPLinkDB/APPLinkDB";
import Info from "./General/Info/Info";
import AdminInfo from "./AdminTools/AdminInfo/AdminInfo";
import TerminationsAPP from "./APP/Terminations/Terminations";
import TerminationsACPP from "./ACPP/Terminations/Terminations";
import TerminationsACC from "./ACC/Terminations/Terminations";
import SignInLogs from "./AdminTools/SignInLogs/SignInLogs";
import ActivityLogs from "./AdminTools/ActivityLogs/ActivityLogs";
import InternalAdminTool from "./ACC/InternalAdminTool/InternalAdminTool";
import CreateCustomerACC from "./ACC/CreateCustomer/CreateCustomer";
import UsageTelemetryACC from "./ACC/UsageTelemetry/UsageTelemetry";
import UsageTelemetryACPP from "./ACPP/UsageTelemetry/UsageTelemetry";
import SurveyJSTemplates from "./ACC/SurveyJSTemplates/SurveyJSTemplates";
import DbBackups from "./APP/DbBackups/DbBackups";
import DataExportsAPP from "./APP/DataExports/DataExports";
import DataExportsACC from "./ACC/DataExports/DataExports";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const msalInstance = new PublicClientApplication(msalConfig);

const router = createBrowserRouter([
    {
        path: '/logout',
        element: <Logout />,
        // errorElement: <ErrorPage />,
        // loader: homeLoader,
    },
    {
        element: <SelfServiceTemplate />,
        children: [
            {
                path: '/',
                element: <CustomerListAPP />,
                // errorElement: <ErrorPage />,
                // loader: homeLoader,
            },
            {
                path: '/contact',
                element: <Contact />,
                // errorElement: <ErrorPage />,
                // loader: homeLoader,
            },
            {
                path: '/info',
                element: <Info />,
                // errorElement: <ErrorPage />,
                // loader: homeLoader,
            },
            {
                path: 'peopleplanner/createenvironment',
                element: <CreateEnvironment />,
                // errorElement: <ErrorPage />,
                // loader: postLoader,
            },
            {
                path: 'peopleplanner/customers',
                element: <CustomerListAPP />,
                // errorElement: <ErrorPage />,
                // loader: postLoader,
            },
            {
                path: 'peopleplanner/terminations',
                element: <TerminationsAPP />,
                // errorElement: <ErrorPage />,
                // loader: postLoader,
            },
            {
                path: 'peopleplanner/appgroups',
                element: <AppGroups />,
                // errorElement: <ErrorPage />,
                // loader: postLoader,
            },
            {
                path: '/peopleplanner/appoctosync',
                element: <APPOctoSync />,
                // errorElement: <ErrorPage />,
                // loader: homeLoader,
            },
            {
                path: '/peopleplanner/applinkdb',
                element: <APPLinkDB />,
                // errorElement: <ErrorPage />,
                // loader: homeLoader,
            },
            {
                path: 'peopleplanner/dbbackups',
                element: <DbBackups />,
                // errorElement: <ErrorPage />,
                // loader: homeLoader,
            },
            {
                path: 'peopleplanner/dataexports',
                element: <DataExportsAPP />,
            },
            {
                path: 'carecompliance/customers',
                element: < CustomerListACC/>,
                // errorElement: <ErrorPage />,
                // loader: postLoader,
            },
            {
                path: 'carecompliance/internaladmintool',
                element: < InternalAdminTool/>,
                // errorElement: <ErrorPage />,
                // loader: postLoader,
            },
            {
                path: 'carecompliance/createcustomer',
                element: <CreateCustomerACC />,
            },
            {
                path: 'carecompliance/terminations',
                element: <TerminationsACC />,
            },
            {
                path: 'carecompliance/usagetelemetry',
                element: <UsageTelemetryACC />,
            },
            {
                path: 'carecompliance/surveyjstemplates',
                element: <SurveyJSTemplates />,
            },
            {
                path: 'carecompliance/dataexports',
                element: <DataExportsACC />,
            },
            {
                path: 'policiesandprocedures/organisations',
                element: < CustomerListACPP/>,
                // errorElement: <ErrorPage />,
                // loader: postLoader,
            },

            {
                path: 'policiesandprocedures/terminations',
                element: < TerminationsACPP/>,
                // errorElement: <ErrorPage />,
                // loader: postLoader,
            },
            {
                path: 'policiesandprocedures/usagetelemetry',
                element: <UsageTelemetryACPP />,
            },
            {
                path: '/admin/info',
                element: <AdminInfo />,
                // errorElement: <ErrorPage />,
                // loader: homeLoader,
            },
            {
                path: '/admin/signinlogs',
                element: <SignInLogs />,
                // errorElement: <ErrorPage />,
                // loader: homeLoader,
            },
            {
                path: '/admin/activitylogs',
                element: <ActivityLogs />,
                // errorElement: <ErrorPage />,
                // loader: homeLoader,
            }
        ]
    }
]);

root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <App router={router}/>
        </MsalProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
